module.exports = require('./helpers/bundle-url').getBundleURL('4KNYk') + "logo.c51670a8.svg";